import { useMemo } from "react";
import { useOrdreStore } from "@store/ordreStore";
import { navigateTo } from "context/navigation.service";
import Icon1 from "@assets/icons/Icon";
import { ORDRE_FLAG_CONFIG } from "types/ordre";

export default function OrdresBloquesWidget() {
  const ordres = useOrdreStore((s) => s.ordres);

  const flagged = useMemo(() => {
    return ordres.filter(
      (o) => o.flags && o.flags.includes("bloque")
    ).slice(0, 8);
  }, [ordres]);

  const cfg = ORDRE_FLAG_CONFIG.bloque;

  return (
    <div className="flex flex-col bg-white border rounded-xl p-4 gap-2 shadow-lg">
      <div className="flex flex-row justify-between items-center mb-1">
        <div className="font-semibold text-black">Ordres bloqués</div>
        {flagged.length > 0 && (
          <span className="text-h4 font-medium rounded-full px-2 py-0.5" style={{ background: cfg.bg, color: cfg.color }}>
            {flagged.length}
          </span>
        )}
      </div>
      {flagged.length === 0 && (
        <div className="text-h3 text-neutral-400 py-2">Aucun ordre bloqué</div>
      )}
      <div className="flex flex-col divide-y">
        {flagged.map((order) => (
            <div
              key={order.id}
              className="flex flex-row items-center py-2.5 px-1 gap-3 cursor-pointer hover:bg-neutral-50 rounded-lg"
              onClick={() => navigateTo({ route: `/ordre/${order.id}` })}
            >
              <div
                className="flex-shrink-0 rounded-full flex items-center justify-center"
                style={{ width: 28, height: 28, background: cfg.bg }}
              >
                <Icon1 name={cfg.icon} size={14} color={cfg.color} />
              </div>
              <div className="flex flex-col flex-1 min-w-0">
                <div className="text-h2 font-medium text-black truncate">{order.name}</div>
                <div className="text-h3 text-neutral-400">{order.immatriculation}</div>
              </div>
              {order.flag_reason && (
                <span className="text-h4 text-neutral-400 truncate max-w-[140px]">{order.flag_reason}</span>
              )}
            </div>
        ))}
      </div>
    </div>
  );
}
